import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../Dashboard/Header";
import axios from "axios";
import {
  Box,
  Grid,
  Paper,
  TextField,
  Switch,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";

export default function GroupDetails() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [GroupDetails, setGrpDetails] = useState(null);
  const [isgrpEnabled, setIsgrpEnabled] = useState(false);
  const [approvalLevel, setApprovalLevel] = useState("");
  const userRole = localStorage.getItem("userRole");
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");

  // ========================================================

  const Groupdetail = async (id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/display/group`,
        { cmpid },
        { headers: { Authorization: token } }
      );
      // console.log(response.data);
      const GrpDetails = response.data.groupMap[0].group;
      // console.log(GrpDetails)
      const selected = GrpDetails.find((v) => v.groupId === id);
      setGrpDetails(selected ?? null);
      //  console.log(selected)

      if (selected.approvalConfig && selected.approvalConfig.length > 0) {
        setIsgrpEnabled(selected.approvalConfig.length > 0);
        setApprovalLevel(selected.approvalConfig[0].level);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //   ========================================================

  const [ModuleStatus, setModuleStatus] = useState([]);

  const ModuleOnOff = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/module/enabledModuleslist",
        { cmpid },
        {
          headers: { Authorization: token },
        }
      );
      const ModuleData = Object.values(response.data);
      //    console.log(ModuleData[0]);
      setModuleStatus(ModuleData[0]);
    } catch (error) {
      // error alert
      console.log(error);
    }
  };

  useEffect(() => {
    Groupdetail(id);
    ModuleOnOff();
  }, [id]);

  const handleSubmit = async () => {
    try {
      const bodydata = [
        {
          TypeName: GroupDetails.groupName,
          type: "ledger",
          level: approvalLevel,
          cmpId: cmpid,
          enable: isgrpEnabled === true ? 1 : 0,
        },
      ];

      // console.log(bodydata);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/approvalModule/insertMasterTypesAppConfig`,
        bodydata,
        { headers: { Authorization: token } }
      );
      // Success Alert
      Swal.fire({
        title: "success!",
        text:
          GroupDetails.groupName +
          ":- Group Configuration Submitted Successfully",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/Infinite/LedGroup");
        }
      });
    } catch (error) {
      // error alert
      console.log(error);
    }
  };

  if (!GroupDetails) {
    return (
      <Box p={4}>
        <Typography variant="h4" color="error">
          Group Not Found
        </Typography>
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate(-1)}>
          ⬅ Go Back
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Box p={{ xs: 2, md: 4 }} mt={8}>
        <Box
          mb={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Header
            title="Group Details"
            subtitle={`Details for ${GroupDetails.groupName}`}
          />
          <Button variant="outlined" onClick={() => navigate(-1)}>
            ⬅ Back
          </Button>
        </Box>

        <Paper
          elevation={6}
          sx={{ p: 4, borderRadius: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Name"
                value={GroupDetails.groupName}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Parent"
                value={GroupDetails.groupParent}
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </Grid>
          </Grid>
          {userRole === "admin" &&
            ModuleStatus?.cmp_id === cmpid &&
            ModuleStatus?.status === 1 && (
              <>
                {/* Toggle: Enable Detail Module */}
                <Box mt={3} display="flex" alignItems="center" gap={1}>
                  <Typography>Enable Group Level</Typography>
                  <Switch
                    checked={isgrpEnabled}
                    onChange={(e) => setIsgrpEnabled(e.target.checked)}
                    color="success"
                  />
                </Box>

                {/* Conditional Extra Fields */}
                {isgrpEnabled && (
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth>
                        <InputLabel id="approval-label">
                          Approval Level
                        </InputLabel>
                        <Select
                          labelId="approval-label"
                          value={approvalLevel}
                          label="Approval Level"
                          onChange={(e) => setApprovalLevel(e.target.value)}
                        >
                          <MenuItem value="1">First Level</MenuItem>
                          <MenuItem value="2">Second Level</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                )}
              </>
            )}

          <Box mt={4} textAlign="right">
            <Button
              variant="contained"
              color="success"
              sx={{ px: 4, py: 1.5 }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
